import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query/types/react/types';
import { LoginConfigApi, SetDefaultTimezoneDto } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

type UseSetDefaultTimezone = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>,
    ErrorResponse,
    SetDefaultTimezoneDto>,
    'mutationFn'>,
) => UseMutationResult<AxiosResponse<void>,
  ErrorResponse,
  SetDefaultTimezoneDto>;

export const useSetDefaultTimezone: UseSetDefaultTimezone = (
  options,
) => {
  const loginConfigApi = new LoginConfigApi(getApiConfiguration());
  return useMutation(
    (setDefaultLocaleDto: SetDefaultTimezoneDto) =>
      loginConfigApi.setDefaultTimezone(setDefaultLocaleDto),
    options,
  );
};
